
import eventTrackingMixins from '~/mixins/eventTrackingMixins.js';
import eventTrackingQdapMallFnMixins from '~/mixins/eventTrackingQdapMallFnMixins.js';
export default {
    name: "QdapHomeSelectionSection",
    
    mixins: [eventTrackingMixins, eventTrackingQdapMallFnMixins],

    props: {
    
        data: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            pageData: null,
        }
    },

    mounted() {
    },
    methods: {
        gotoAnchor(anchorCode) {
            this.$emit('gotoAnchor', anchorCode);
            this.$router?.push({ path: '/#'+anchorCode });
        }
    },
}
